// Thin client for the booking serverless API. Same-origin in production and
// under `vercel dev`; see SETUP-BOOKING.md for local development.

async function jsonOrThrow(res) {
  let data = {};
  try {
    data = await res.json();
  } catch {
    /* ignore */
  }
  if (!res.ok) {
    const message = data && data.error ? data.error : `Request failed (${res.status})`;
    const err = new Error(message);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export async function fetchAvailability(eventId) {
  const res = await fetch(`/api/availability?eventId=${encodeURIComponent(eventId)}`);
  return jsonOrThrow(res);
}

export async function createCheckoutSession(booking) {
  const res = await fetch("/api/create-checkout-session", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(booking),
  });
  return jsonOrThrow(res);
}

export async function fetchSessionStatus(sessionId) {
  const res = await fetch(`/api/session-status?session_id=${encodeURIComponent(sessionId)}`);
  return jsonOrThrow(res);
}

export async function fetchGuestList(eventId, key) {
  const res = await fetch(
    `/api/guest-list?eventId=${encodeURIComponent(eventId)}&key=${encodeURIComponent(key)}`
  );
  return jsonOrThrow(res);
}

export function formatGBP(pence) {
  if (typeof pence !== "number") return "";
  return new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(
    pence / 100
  );
}
